module.exports = __webpack_public_path__ + "img/See-a-DEMO-popup-th.06f28a2.png";